app.component("ocularHistory", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/ocularHistory/ocularHistory.html",
	controller: "ocularHistoryController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("ocularHistoryController", [
	"$scope",
	function ($scope) {
	

		this.$onInit = function () {};

    
	},
]);